import styles from "../add.module.css";
import { useForm } from "react-hook-form";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import moment from "moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { authData } from "../../../../admin/components/GetAuth";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect } from "react";
import { StorageSetItem } from "../../../../admin/components/StorageComp";

const Step4 = ({ bookingData, backToTab, setLoading, setSnackbarMessage, setSnackbarType, setSnackbarOpen, booking_id }) => {
  const auth = authData();
  const navigate = useNavigate();
  const [SubTotal, setSubTotal] = useState(0);
  const [Total, setTotal] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [DeliverySubTotal, setDeliverySubTotal] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onChange" });

  useEffect(() => {
    let subtotalTemp = 0;
    let deliverySubtotalTemp = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;

    bookingData?.products?.forEach((item) => {
      subtotalTemp += parseFloat(item.total);
    });
    setSubTotal(subtotalTemp);
    if (bookingData?.is_delivery) {
      bookingData?.delivery_products?.forEach((item) => {
        deliverySubtotalTemp += parseFloat(item.total);
      });
    }
    setDeliverySubTotal(deliverySubtotalTemp);

    setDiscountVal(bookingData?.discountVal);
    setDiscountAmount(bookingData?.discountAmount);
    setReferralDiscount(bookingData?.referralDiscount);

    if (bookingData?.discountAmount) {
      discountTemp = bookingData?.discountAmount;
    }

    if (bookingData?.referralDiscount) {
      discountTemp2 = bookingData?.referralDiscount;
    }

    setTotal(subtotalTemp + deliverySubtotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
  }, [bookingData]);

  const onSubmit = (data) => {
    let noOfItems = 0;
    let subTotal = 0;
    let deliverySubTotal = 0;
    let deliveryProducts = [];

    let products = bookingData.products.map((item) => {
      noOfItems += 1;
      subTotal += parseFloat(item.total);
      return {
        product_id: item?.item_id,
        product_title: item?.item_name,
        price: item?.total,
        quantity: 1,
        sub_amount: item.total,
        is_fragile: item?.is_fragile ? 1 : 0,
      };
    });

    if (bookingData?.is_delivery) {
      deliveryProducts = bookingData.delivery_products.map((item) => {
        deliverySubTotal += parseFloat(item.total);
        return {
          id: item?.id ? item?.id : 0,
          product_id: item?.item_id,
          product_title: item?.item_name,
          price: item?.price !== "" ? item?.price : 0,
          quantity: item?.quantity,
          sub_amount: item.total
        };
      });
    }

    let postData = {
      customer_id: auth?.customer?.id,
      description: bookingData?.notes,
      no_of_items: noOfItems,
      insurance: bookingData?.insurance,
      company_shipping: bookingData?.company_shipping,
      company_name: bookingData?.company_name,
      registered_company: bookingData?.registered_company,
      pickup_date: moment(bookingData?.pickup_date).format("YYYY-MM-DD"),
      total: subTotal + deliverySubTotal - discountAmount - referralDiscount,
      amount: subTotal,
      delivery_total: deliverySubTotal,
      post_code: bookingData?.pickUpData?.post_code,
      products: products,
      pickUpData: bookingData?.pickUpData,
      recipientData: bookingData?.recipientData,
      is_delivery: bookingData?.is_delivery ? 1 : 0,
      deliveryProducts: deliveryProducts,
      discount_val: discountVal,
      discount_amount: discountAmount,
      referral_discount: referralDiscount
    }

    setLoading(true);

    if (booking_id) {
      axios.post(process.env.REACT_APP_API_URL + "v1/customer/bookings/" + booking_id, postData, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          navigate("/customer/my-bookings");
        }
      }).catch((error) => {
        setLoading(false);
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/bookings", postData, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          if (auth) {
            let authTemp = auth;
            let customerData = authTemp?.customer;
            if (customerData) {
              let referral_amount = customerData?.referral_amount;
              if (referral_amount) {
                referral_amount = parseFloat(referral_amount);
                referral_amount = referral_amount - parseFloat(referralDiscount);
              } else {
                referral_amount = 0;
              }

              if (referral_amount < 0) {
                referral_amount = 0;
              }

              customerData = { ...customerData, referral_amount: referral_amount, referral_point: referral_amount?.toFixed(2) };
            }
            authTemp = { ...authTemp, customer: customerData };
            StorageSetItem("bookAuthData", JSON.stringify(authTemp), 24 * 60 * 60 * 1000);
          }

          navigate("/customer/my-bookings");
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
  }

  return (<>
    <div className={`${styles.CustomWidth}`}>
      <div className={`${styles.SummerySec}`}>
        <div className={`${styles.SummerySecUnder}`}>
          <div className={`${styles.SummerySecRow}`}>
            <div className={`${styles.SummerySecFull}`}>
              <p>Customer Name:</p>
              <p>{bookingData?.user_id?.label}</p>
            </div>
            <div className={`${styles.SummerySecHalf} ${styles.SummerySecHalf1}`}>
              <p className={`${styles.StepBoxTitle2}`}>CONFIRM YOUR USER DETAILS</p>
              <ul className={`${styles.SummeryListSec}`}>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.name}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.address}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Post Code:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.post_code}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.phone && formatPhoneNumberIntl(bookingData?.pickUpData?.phone)}</p>
                </li>
              </ul>
            </div>

            <div className={`${styles.SummerySecHalf}  ${styles.SummerySecHalf2}`}>
              <p className={`${styles.StepBoxTitle2} ${styles.Heading}`} style={{ background: "#002e5b" }}>CONFIRM YOUR RECIPIENT DETAILS</p>
              <ul className={`${styles.SummeryListSec}`}>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.name}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.address}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.phone && formatPhoneNumberIntl(bookingData?.recipientData?.phone)}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <p className={`${styles.StepBoxTitle}`}>CONFIRM YOUR ITEM DETAILS</p>
      {bookingData?.is_delivery && <div className={`${styles.TableSec}`} style={{ marginBottom: '30px' }}>
        <table>
          <tr style={{ background: "#ef233c", color: "#fff" }}>
            <td className={`${styles.TableHead}`} style={{ color: "#fff", paddingLeft: "5px" }}>Delivery Item</td>
            <td className={`${styles.TableHead}`} style={{ color: "#fff" }}>Quanity</td>
            <td className={`${styles.TableHead}`} style={{ color: "#fff", paddingRight: "5px" }}>Total</td>
          </tr>
          {bookingData?.delivery_products?.map((item) => {
            return (<tr style={{ background: "#D1E7FC" }}>
              <td className={`${styles.TableCon}`} style={{ paddingLeft: "5px", borderBottom: "1px solid #fff" }}>{item?.item_name}</td>
              <td className={`${styles.TableCon}`} style={{ borderBottom: "1px solid #fff" }}>{item?.quantity}</td>
              <td className={`${styles.TableCon}`} style={{ paddingRight: "5px", borderBottom: "1px solid #fff" }}>&pound; {parseFloat(item.total).toFixed(2)}</td>
            </tr>);
          })}
        </table>
      </div>}
      <div className={`${styles.TableSec}`}>
        <table>
          <tr style={{ background: "#002e5b", color: "#fff" }}>
            <td className={`${styles.TableHead}`} style={{ color: "#fff", paddingLeft: "5px" }}>Pickup Item</td>
            <td className={`${styles.TableHead}`} style={{ color: "#fff" }}>Fragile</td>
            <td className={`${styles.TableHead}`} style={{ color: "#fff", paddingRight: "5px" }}>Estimated Value</td>
          </tr>
          {bookingData?.products?.map((item) => {
            return (<tr style={{ background: "#D1E7FC" }}>
              <td className={`${styles.TableCon}`} style={{ paddingLeft: "5px", borderBottom: "1px solid #fff" }}>{item?.item_name}</td>
              <td className={`${styles.TableCon}`} style={{ borderBottom: "1px solid #fff" }}>{item?.is_fragile ? "Yes" : "No"}</td>
              <td className={`${styles.TableCon}`} style={{ paddingRight: "5px", borderBottom: "1px solid #fff" }}>&pound; {parseFloat(item.total).toFixed(2)}</td>
            </tr>);
          })}
          <tr>
            <td colSpan="2" className={`${styles.TableCon}`}>
              <p className={`${styles.SummeryPPTI}`}>Order Subtotal:</p>
              {bookingData?.is_delivery && <p className={`${styles.SummeryPPTI}`}>Delivery Subtotal:</p>}
              {discountVal > 0 && <p className={`${styles.SummeryPPTI}`}>Membership Discount({discountVal}%):</p>}
              {referralDiscount > 0 && <p className={`${styles.SummeryPPTI}`}>Referral Discount:</p>}
              <p className={`${styles.SummeryPPTI}`}>Total VAT:</p>
              <p className={`${styles.SummeryPPTI}`}>Insurance Charges:</p>
              <p className={`${styles.SummeryPPTI} ${styles.Big}`}>Total:</p>
            </td>
            <td className={`${styles.TableCon}`}>
              <p className={`${styles.SummeryPPTE}`}>£{SubTotal.toFixed(2)}</p>
              {bookingData?.is_delivery && <p className={`${styles.SummeryPPTE}`}>£{DeliverySubTotal.toFixed(2)}</p>}
              {discountVal > 0 && <p className={`${styles.SummeryPPTE}`}>-£{discountAmount.toFixed(2)}</p>}
              {referralDiscount > 0 && <p className={`${styles.SummeryPPTE}`}>-£{referralDiscount.toFixed(2)}</p>}
              <p className={`${styles.SummeryPPTE}`}>£{VATCharge.toFixed(2)}</p>
              <p className={`${styles.SummeryPPTE}`}>£{InsuranceCharge.toFixed(2)}</p>
              <p className={`${styles.SummeryPPTE} ${styles.Big}`}>£{Total.toFixed(2)}</p>
            </td>
          </tr>
        </table>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>To be collected:</p>
        <p className={`${styles.TableConSecText}`}>{moment(bookingData.pickup_date).format("ddd MMM D, YYYY")}</p>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>Booking Notes:</p>
        <p className={`${styles.TableConSecText}`}>{bookingData?.notes}</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControlLabel
          control={<Checkbox {...register("is_accept", { required: true })} />}
          label="I confirm that the order summary above is correct *"
          className={`${styles.CheckBox} CheckBox`}
        />
        {errors?.is_accept && (<p className={`${styles.ErrorM}`}>Please accept terms & condition</p>)}

        <div className={`${styles.StepBUSec}`}>
          <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
          <button type="submit" className={`${styles.Next}`}>Confirm Booking</button>
        </div>
      </form>
    </div>
  </>);
}

export default Step4;